import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UnitAccountLimits } from 'src/app/shared/models/unit-bank-account/UnitAccountLimits.model';

export class UnitBankAccountLimitDialogParams {
  accountLimits:UnitAccountLimits;
  displayDailyDebit:boolean;
  displayMonthlyDebit:boolean;
}

@Component({
  selector: 'terra-unit-bank-account-limit-dialog',
  templateUrl: './unit-bank-account-limit-dialog.component.html',
  styleUrls: ['./unit-bank-account-limit-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitBankAccountLimitDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<UnitBankAccountLimitDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UnitBankAccountLimitDialogParams
  ) {
    dialogRef.updateSize('360px');
   }

  ngOnInit(): void {

  }

}
